MOVE.SRP.CardPropertyDetails = (function (SRP) {
  "use strict";
  // the purpose of this model is to reduce
  // the dom serialization requirements for srp card leads
  // where possible, we should grab data attributes from
  // existing dom elements rather than adding to the dom

  var CardPropertyDetails = (function(){
    var constructor,
        $element,
        $dataField,
        FIELD_MAPPING,
        DOM_MAPPING,
        mappedFields,
        withDomMapping,
        mappedDomText,
        mappedDomAttr;

    // data fields to map to property object
    // fields to be set are keys
    // existing fields are values
    FIELD_MAPPING = {
      property_id: 'propertyid',
      listing_id: 'listingid',
      property_type: 'status',
      plan_name: 'plan_name',
      community_name: 'community_name'
    };

    mappedFields = function() {
      return _.mapObject(FIELD_MAPPING, _.partial(_.result, $dataField.data()));
    };

    DOM_MAPPING = {
      text: {
        price_display: '.price .data-price',
        address: '.address .listing-street-address',
        city: '.address .listing-city',
        state_code: '.address .listing-region',
        postal_code: '.address .listing-postal',
        beds: '.prop-meta [data-label="property-meta-beds"] .data-value.meta-beds',
        beds_display: '.prop-meta [data-label="property-meta-beds"] .data-value.meta-beds-display',
        sqft_display: '.prop-meta [data-label="property-meta-sqft"] .data-value',
        lot_size_display: '.prop-meta [data-label="property-meta-lotsize"] .data-value'
      },
      attr: {
        'data-src': {
          photo_url: ".photo-wrap img.js-srp-listing-photos:not(.coming-soon-lg):not(.coming-soon-sm)"
        },
        'alt': {
          full_address_display: ".photo-wrap img.js-srp-listing-photos:not(.coming-soon-lg):not(.coming-soon-sm)"
        },
        content: {
          long: ".listing-geo [itemprop='longitude']",
          lat: ".listing-geo [itemprop='latitude']"
        }
      }
    };

    withDomMapping = function(mapping, callback) {
      return _.mapObject(mapping, function(selector) {
        return callback($element.find(selector));
      });
    };

    mappedDomText = function() {
      return withDomMapping(DOM_MAPPING.text, function($child) { return $child.text() || null; });
    };

    mappedDomAttr = function(attr) {
      return withDomMapping(DOM_MAPPING.attr[attr], function($child) { return $child.attr(attr) || null; });
    };

    constructor = function(element) {
      $element = element;
      $dataField = $element.find('.data-wrap');
      return _.extend(
        $dataField.data(),
        mappedFields(),
        mappedDomText(),
        mappedDomAttr('data-src'),
        mappedDomAttr('alt'),
        mappedDomAttr('content')
      );
    };

    return constructor;
  })();


  SRP.CardPropertyDetails = CardPropertyDetails;

  return SRP.CardPropertyDetails;

})(MOVE.SRP || {});



// WEBPACK FOOTER //
// ./srp/models/card_property_details.js